import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { ssoLogin, getPermissions, getSiteRoleAdminRoles } from '../../axios';
import ShowSkeleton from './ShowSkeleton';
import { message } from "antd";
import routesConfig from '../../routes/config';

const SsoCallback = (props) => {
    const { history, t } = props;

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const ticket = urlParams.get('ticket');
        if (!ticket) {
            history.replace('/');
            return;
        }
        ssoLogin({ ticket }).then(res => {
            if (res.code === 100000 && res.data) {
                localStorage.setItem('user', JSON.stringify(res));
                getPermissions({ id: res.data.id }).then(pRes => {
                    if (pRes.code === 100000 && pRes.data && pRes.data.permissions && pRes.data.permissions.menu) {
                        const menuList = pRes.data.permissions.menu;
                        if (menuList.length > 0 && menuList[0].code) {
                            // Match the route key through routesConfig and menuList[0].code
                            let matchedPath = '';
                            const findRoutePath = (menus, code) => {
                                for (let i = 0; i < menus.length; i++) {
                                    const menu = menus[i];
                                    if (menu.code === code) {
                                        // If the menu has subs, return the first sub key in menuList that matches code
                                        if (menu.subs && menu.subs.length > 0) {
                                            // menuList may contain multiple codes, prefer to find the sub in menuList that matches code
                                            const subCode = menuList.find(m => menu.subs.some(sub => sub.code === m.code));
                                            if (subCode) {
                                                const subMenu = menu.subs.find(sub => sub.code === subCode.code);
                                                if (subMenu) return subMenu.key;
                                            }
                                            // If not found, return the first sub key
                                            return menu.subs[0].key;
                                        }
                                        return menu.route || menu.key || '';
                                    }
                                    if (menu.subs) {
                                        const subPath = findRoutePath(menu.subs, code);
                                        if (subPath) return subPath;
                                    }
                                }
                                return '';
                            };
                            matchedPath = findRoutePath(routesConfig.menus, menuList[0].code);
                            if (matchedPath) {
                                history.replace(matchedPath);
                            } else {
                                history.replace('/');
                            }
                        } else if (menuList.length === 0) {
                            getSiteRoleAdminRoles({ id: res.data.id, params: { page: 1, per_page: 10 } }).then(roleRes => {
                                if (roleRes.data.roles.some(item => item.role_id === 1)) {
                                    history.replace('/updatelog');
                                } else {
                                    message.warning(t('PermissionForThis'))
                                    history.replace('/');
                                }
                            })
                        } else {
                            message.warning(t('PermissionForThis'))
                            history.replace('/');
                        }
                    } else {
                        message.warning(pRes.msg)
                        history.replace('/');
                    }
                });
            } else {
                message.warning(res.msg)
                history.replace('/');
            }
        });
    }, [history]);

    return (
    <ShowSkeleton tips="Logging in, please wait..." />
    );
};

export default withRouter(withTranslation(['common'])(SsoCallback))
